import { useLayoutEffect, useRef, useState } from "react"
import Axios from "axios"


export default function AcademySelect(props) {

    const isMounted = useRef(0)

    const templateId = props['templateId']
    const branchList = props['branchList']
    const Set_branchList = props['Set_branchList']
    const includeMode = props['includeMode']
    const Set_includeMode = props['Set_includeMode']

    const left = useRef()
    const right = useRef()
    const include = useRef()

    const [academyList, Set_academyList] = useState([])
    const [leftList, Set_leftList] = useState([])
    const [rightList, Set_rightList] = useState([])

    const [leftSearch, Set_leftSearch] = useState("")
    const [rightSearch, Set_rightSearch] = useState("")

    useLayoutEffect(() => {
        get_academy()
    }, [])

    useLayoutEffect(() => {
        if(isMounted.current === 1) {
            Set_leftList(academyList)
            isMounted.current++
        }
    }, [academyList])

    useLayoutEffect(() => {
        if(isMounted.current === 2) {
            const left_list = academyList.filter(x => {
                return branchList.indexOf(x['BranchID']) === -1
            })
            left_list.sort((a, b) => a['Sort'] - b['Sort'])
            Set_leftList(left_list)

            const right_list = academyList.filter(x => {
                return branchList.indexOf(x['BranchID']) !== -1
            })
            right_list.sort((a, b) => a['Sort'] - b['Sort'])
            Set_rightList(right_list)

            if(includeMode) {
                include.current.checked = true
            }
            else {
                include.current.checked = false
            }
        }
    }, [templateId])

    useLayoutEffect(() => {
        if(isMounted.current === 2) {
            const new_list = []
            for(let i=0; i<rightList.length; i++) {
                new_list.push(rightList[i]['BranchID'])
            }
            Set_branchList(new_list)
        }
    }, [rightList])

    async function get_academy() {
        const result =
            await Axios
            .post("/damo/academy")

        Set_academyList(result['data'])
        isMounted.current++
    }

    async function aaa(props) {
        const set = props['set']

        let target = ''
        if(set === 'right') {
            target = left.current
        }
        else if(set === 'left') {
            target = right.current
        }

        const move_list = []
        const www = target.querySelectorAll('option:checked')
        for(let i=0; i<www.length; i++) {
            move_list.push(www[i].value)
        }

        if(set === 'right') {
            const left_list = leftList.filter(x => {
                return move_list.indexOf(x['BranchID']) === -1
            })
            left_list.sort((a, b) => a['Sort'] - b['Sort'])
            Set_leftList(left_list)

            const right_list = academyList.filter(x => {
                return move_list.indexOf(x['BranchID']) !== -1
            })
            right_list.push(...rightList)
            right_list.sort((a, b) => a['Sort'] - b['Sort'])
            Set_rightList(right_list)
        }
        else if(set === 'left') {
            const right_list = rightList.filter(x => {
                return move_list.indexOf(x['BranchID']) === -1
            })
            right_list.sort((a, b) => a['Sort'] - b['Sort'])
            Set_rightList(right_list)

            const left_list = academyList.filter(x => {
                return move_list.indexOf(x['BranchID']) !== -1
            })
            left_list.push(...leftList)
            left_list.sort((a, b) => a['Sort'] - b['Sort'])
            Set_leftList(left_list)
        }
    }

    async function change_mode(checked) {
        if(checked) {
            Set_includeMode(true)
        }
        else {
            Set_includeMode(false)
        }
    }

    return(
        <div
            style={{
                backgroundColor: "#EFEFEF",
                borderRadius: "5px",
                padding: "10px",
                boxSizing: "border-box",
                marginBottom: "10px"
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center"
                }}
            >
                <div>학원 선택</div>
                <div>
                    <label>
                        <input
                            type="checkbox"
                            onClick={(e) => change_mode(e.currentTarget.checked)}
                            ref={include}
                        />
                        <span>포함</span>
                    </label>
                </div>
            </div>

            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "500px",
                    boxSizing: "border-box"
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "300px",
                        height: "100%"
                    }}
                >
                    <label style={{textAlign: "center"}}>
                        {includeMode === false && <span>포함</span>}
                        {includeMode === true && <span>미포함</span>}
                    </label>
                    <input
                        type="text"
                        value={leftSearch}
                        onChange={(e) => Set_leftSearch(e.currentTarget.value)}
                    ></input>
                    <select
                        style={{
                            width: "100%",
                            height: "100%"
                        }}
                        multiple={true}
                        ref={left}
                    >
                        {leftList
                        .map((value, index) => {
                            return(
                                <option
                                    key={index}
                                    value={value['BranchID']}
                                    style={{
                                        display: value['BranchName'].indexOf(leftSearch) === -1 ? "none" : "block"
                                    }}
                                >{value['BranchName']}</option>
                            )
                        })}
                    </select>
                </div>

                <div>
                    <button type="button" onClick={() => aaa({set: 'right'})}>▶</button>
                    <button type="button" onClick={() => aaa({set: 'left'})}>◀</button>
                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "300px",
                        height: "100%"
                    }}
                >
                    <label style={{textAlign: "center"}}>
                        {includeMode === false && <span>미포함</span>}
                        {includeMode === true && <span>포함</span>}
                    </label>
                    <input
                        type="text"
                        value={rightSearch}
                        onChange={(e) => Set_rightSearch(e.currentTarget.value)}
                    ></input>
                    <select
                        style={{
                            width: "100%",
                            height: "100%"
                        }}
                        multiple={true}
                        ref={right}
                    >
                        {rightList
                        .map((value, index) => {
                            return(
                                <option
                                    key={index}
                                    value={value['BranchID']}
                                    style={{
                                        display: value['BranchName'].indexOf(rightSearch) === -1 ? "none" : "block"
                                    }}
                                >{value['BranchName']}</option>
                            )
                        })}
                    </select>
                </div>
            </div>
        </div>
    )
}